import { DialogActions, Stack, Box, Typography, Button } from '@mui/material';
import { OrderActionEnum, OrderDto } from 'desk-common';
import { formatCurrency } from '../../utils/functions/formatCurrency';
import {
  ACTION_BUTTON_BASE_SX,
  OrderActionConfig,
} from './constants/orderAction';

type Props = {
  isLoading: boolean;
  total: number;
  availableActions: OrderActionConfig[];
  pendingAction: OrderActionEnum | null;
  order: OrderDto | null;
  hasUnsavedChanges: boolean;
  isSendButtonEnabled: boolean;
  showDraftButtons: boolean;
  onSubmit: (action: OrderActionEnum) => Promise<void>;
};

export default function OrderModalFooter({
  isLoading,
  total,
  availableActions,
  pendingAction,
  order,
  hasUnsavedChanges,
  isSendButtonEnabled,
  showDraftButtons,
  onSubmit,
}: Props) {
  if (isLoading) {
    return <DialogActions sx={{ py: 3 }} />;
  }

  return (
    <DialogActions
      sx={{
        px: 4,
        py: 3,
        borderTop: '1px solid #eee',
        position: 'sticky',
        bottom: 0,
        backgroundColor: '#fff',
        backdropFilter: 'blur(10px)',
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        <Box>
          <Typography variant="caption" color="text.secondary">
            Total del pedido
          </Typography>
          <Typography variant="h4" fontWeight={800}>
            {formatCurrency(total)}
          </Typography>
        </Box>

        <Stack direction="row" spacing={2}>
          {availableActions.map((item: OrderActionConfig) => (
            <Button
              key={item.action}
              variant={item.variant}
              color={item.color}
              loading={pendingAction === item.action}
              disabled={
                Boolean(pendingAction) ||
                (Boolean(order) &&
                  item.action === OrderActionEnum.SEND &&
                  hasUnsavedChanges)
              }
              startIcon={<item.icon />}
              sx={{ ...ACTION_BUTTON_BASE_SX, ...item.sx }}
              onClick={() => onSubmit(item.action)}
            >
              {item.label}
            </Button>
          ))}

          {showDraftButtons && (
            <>
              <Button
                variant="outlined"
                size="large"
                loading={pendingAction === OrderActionEnum.SAVE_DRAFT}
                disabled={Boolean(pendingAction)}
                onClick={() => onSubmit(OrderActionEnum.SAVE_DRAFT)}
                sx={{ ...ACTION_BUTTON_BASE_SX, px: 4 }}
              >
                {order ? 'Guardar' : 'Guardar Borrador'}
              </Button>
              <Button
                variant="contained"
                size="large"
                loading={pendingAction === OrderActionEnum.SEND}
                disabled={Boolean(pendingAction) || !isSendButtonEnabled}
                onClick={() => onSubmit(OrderActionEnum.SEND)}
                sx={{ ...ACTION_BUTTON_BASE_SX, px: 4 }}
              >
                Enviar
              </Button>
            </>
          )}
        </Stack>
      </Stack>
    </DialogActions>
  );
}
